jQuery( function ( $ ) {

  const $modal = $( '#personnel-modal' );
  if ( !$modal.length ) { return; }

  $modal.on( 'show.bs.modal', function ( e ) {
    const $article = $( e.relatedTarget ).closest( 'article' );

    [ '.name', '.job-title', '.bio' ].forEach( selector => {
      const $article_content_el = $( selector, $article );
      $( selector, $modal ).html( $article_content_el.length ? $article_content_el.html() : '' );
    });

    const $img = $( 'img', $article ).clone();
    $img.attr( 'sizes', [
      '(min-width: 1200px) 400px',
      '(min-width: 992px) 250px',
      '(min-width: 382px) 300px',
      '100vw',
    ].join(',') )
    $( '.img-container', $modal ).html( $img );

  });

});